document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.section--padding');

  sections.forEach(section => {
    const container = section.querySelector('.tab-collage--horizontal-titles');
    if (!container) return;

    const content = container.querySelector('.tab-collage__content');
    const headings = container.querySelectorAll('.tab-collage__heading');
    const descriptions = container.querySelectorAll('.tab-collage__desc');
    const cards = container.querySelectorAll('.tab-collage__card');
    const dots = container.querySelectorAll('.tab-collage__dot');
    const prevBtn = section.querySelector('.tab-collage__nav-prev');
    const nextBtn = section.querySelector('.tab-collage__nav-next');

    let currentIndex = 0;
    let isTransitioning = false;

    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let currentY = 0;
    let isDragging = false;

    function updateSlidePosition() {
      if (window.innerWidth <= 749) {
        const translateX = -currentIndex * 100;
        headings.forEach((heading) => {
          const item = heading.closest('.tab-collage__item');
          item.style.transform = `translateX(${translateX}%)`;
        });
      }
    }

    function updateActiveStates(index) {
      headings.forEach((heading, i) => {
        heading.classList.toggle('is-active', i === index);
      });

      descriptions.forEach((desc, i) => {
        desc.classList.toggle('is-active', i === index);
      });

      cards.forEach((card, i) => {
        card.classList.toggle('is-active', i === index);
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });

      if (prevBtn && nextBtn) {
        prevBtn.classList.toggle('disabled', index === 0);
        nextBtn.classList.toggle('disabled', index === headings.length - 1);
      }
    }

    function goToSlide(index) {
      if (isTransitioning || index < 0 || index >= headings.length) return;

      isTransitioning = true;
      currentIndex = index;

      updateSlidePosition();
      updateActiveStates(index);

      setTimeout(() => {
        isTransitioning = false;
      }, 300);
    }

    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    function prevSlide() {
      goToSlide(currentIndex - 1);
    }

    function handleTouchStart(e) {
      if (window.innerWidth > 749 || isTransitioning) return;

      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = true;
    }

    function handleTouchMove(e) {
      if (!isDragging || window.innerWidth > 749) return;

      currentX = e.touches[0].clientX;
      currentY = e.touches[0].clientY;

      const deltaX = Math.abs(currentX - startX);
      const deltaY = Math.abs(currentY - startY);

      if (deltaX > deltaY) {
        e.preventDefault();
      }
    }

    function handleTouchEnd(e) {
      if (!isDragging || window.innerWidth > 749) return;

      const deltaX = currentX - startX;
      const deltaY = Math.abs(currentY - startY);
      const threshold = 50;

      if (Math.abs(deltaX) > threshold && Math.abs(deltaX) > deltaY) {
        if (deltaX > 0) {
          prevSlide();
        } else {
          nextSlide();
        }
      }

      isDragging = false;
      startX = 0;
      startY = 0;
      currentX = 0;
      currentY = 0;
    }

    headings.forEach((heading, index) => {
      heading.addEventListener('click', () => goToSlide(index));
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => goToSlide(index));
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', prevSlide);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', nextSlide);
    }

    if (content) {
      content.addEventListener('touchstart', handleTouchStart, { passive: false });
      content.addEventListener('touchmove', handleTouchMove, { passive: false });
      content.addEventListener('touchend', handleTouchEnd, { passive: true });
    }

    const imageArea = container.querySelector('.tab-collage__right');
    if (imageArea) {
      imageArea.addEventListener('touchstart', handleTouchStart, { passive: false });
      imageArea.addEventListener('touchmove', handleTouchMove, { passive: false });
      imageArea.addEventListener('touchend', handleTouchEnd, { passive: true });
    }

    function init() {
      updateSlidePosition();
      updateActiveStates(0);

      window.addEventListener('resize', () => {
        setTimeout(() => {
          updateSlidePosition();
        }, 100);
      });
    }

    if (content && headings.length > 0) {
      init();
    }
  });
});
